/**
 * src/routes/colaboradorRoutes.js
 * Rotas protegidas do colaborador
 */

import { lazy, Suspense } from 'react';
import SecureRoute from '../app/Context/privaterouter';
import LoadingSpinner from '../app/ComponentsLogin/LoadingSpinner';

const ColaboradorHome = lazy(() => import('../app/AgendexColaborador/pages/Home/pc_home'));
const ColaboradorAgendamentos = lazy(() => import('../app/AgendexColaborador/pages/Agendamentos/pc_abertos'));
const ColaboradorAgendamentosConcluidos = lazy(() => import('../app/AgendexColaborador/pages/Agendamentos/pc_concluidos'));
const ColaboradorAgendamentosExcluidos = lazy(() => import('../app/AgendexColaborador/pages/Agendamentos/pc_excluidos'));
const ColaboradorAgendamentosPendentes = lazy(() => import('../app/AgendexColaborador/pages/Agendamentos/pc_pendentes'));
const ColaboradorPerfil = lazy(() => import('../app/AgendexColaborador/pages/Perfil/pc_perfil'));
const ColaboradorPerfilValidaEmail = lazy(() => import('../app/AgendexColaborador/pages/Perfil/pc_ativarconta'));

const Protected = (Component) => (
  <SecureRoute>
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  </SecureRoute>
);

export const colaboradorRoutes = [
  { path: "/app/colaborador/home", element: Protected(ColaboradorHome) },
  { path: "/app/colaborador/agendamentos/abertos", element: Protected(ColaboradorAgendamentos) },
  { path: "/app/colaborador/agendamentos/concluidos", element: Protected(ColaboradorAgendamentosConcluidos) },
  { path: "/app/colaborador/agendamentos/excluidos", element: Protected(ColaboradorAgendamentosExcluidos) },
  { path: "/app/colaborador/agendamentos/pendentes", element: Protected(ColaboradorAgendamentosPendentes) },
  { path: "/app/colaborador/perfil", element: Protected(ColaboradorPerfil) },
  { path: "/app/colaborador/perfil/cv", element: Protected(ColaboradorPerfilValidaEmail) }
];